/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SignalRuleCount
 */
export interface SignalRuleCount {
  /**
   *
   * @type {string}
   * @memberof SignalRuleCount
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof SignalRuleCount
   */
  ruleCount: number;
}

/**
 * Check if a given object implements the SignalRuleCount interface.
 */
export function instanceOfSignalRuleCount(
  value: object,
): value is SignalRuleCount {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("ruleCount" in value) || value["ruleCount"] === undefined) return false;
  return true;
}

export function SignalRuleCountFromJSON(json: any): SignalRuleCount {
  return SignalRuleCountFromJSONTyped(json, false);
}

export function SignalRuleCountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SignalRuleCount {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    ruleCount: json["ruleCount"],
  };
}

export function SignalRuleCountToJSON(json: any): SignalRuleCount {
  return SignalRuleCountToJSONTyped(json, false);
}

export function SignalRuleCountToJSONTyped(
  value?: SignalRuleCount | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    ruleCount: value["ruleCount"],
  };
}
